import { Text } from '@nautilusbio/nb-design-system/Text';
import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import bgTexture from './assets/bg-texture.png';
import platformHero from './assets/platform-hero.png';
import styles from './styles.module.css';

const LoginGraphic: FC = () => {
  const { t } = useTranslation('login');

  return (
    <div className={styles.graphicPanel}>
      <img alt="" aria-hidden className={styles.graphicBgTexture} src={bgTexture} />
      <div className={styles.graphicContent}>
        <Text as="p" className={styles.graphicHeading}>
          {t('graphic.heading')}
        </Text>
        <Text as="p" className={styles.graphicSubtitle}>
          {t('graphic.subtitle')}
        </Text>
      </div>
      <div className={styles.graphicImageWrapper}>
        <img alt={t('graphic.image_alt')} className={styles.graphicImage} src={platformHero} />
      </div>
    </div>
  );
};

export default LoginGraphic;
